import { MAXTheme } from "notes";

export const theme = {
  ...MAXTheme,
};
